import { render, staticRenderFns } from "./GroupFile.vue?vue&type=template&id=12397f44"
import script from "./GroupFile.vue?vue&type=script&lang=js"
export * from "./GroupFile.vue?vue&type=script&lang=js"
import style0 from "./GroupFile.vue?vue&type=style&index=0&id=12397f44&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports